import styles from "./Tooltip.module.css"
import { useRef } from "react"
import { createPortal } from "react-dom"
import { useState, useLayoutEffect } from "react"
interface TooltipProps {
    desc: string,
    className?: string,
    targetRef: React.RefObject<HTMLElement | null>,
    children: React.ReactNode
    
}
const Tooltip = ({ desc, className, targetRef, children }: TooltipProps) => {
    const ref = useRef<HTMLSpanElement | null>(null)
  const [tooltipWidth, setTooltipWidth] = useState(0)

  // measure tooltip width after mount
  useLayoutEffect(() => {
    if (ref.current) {
      setTooltipWidth(ref.current.offsetWidth)
    }
  }, [children, desc])

  if (!targetRef?.current) return null

  const rect = targetRef.current.getBoundingClientRect()
        

  return createPortal(
      <span ref={ref} 
      style={{
          position: "absolute",
          top: rect.bottom + window.scrollY + 4, // 4px gap
          left: rect.left + window.scrollX + rect.width / 2 - tooltipWidth / 2, 
          zIndex: 1000,
          opacity: 1,
          }}
          className={`${styles.Tooltip} ${className ? className : ""}`}
      >{children}</span>,
      document.body // Not inside scroll container
  );
    
}
export default Tooltip